import { TrackedChangeType, TrackedChange } from 'prose-core'
import { type TrackedChangesCommandHandler, type BreakOutOfListTrackedChangeCommand } from './types'
import { getTrackedChangesFromNode, wrappedCommand } from './utils'

/*
 * Add a deletion tracked change exclusively to the list item.
 */
export const breakOutOfList: TrackedChangesCommandHandler = ({ originalTr, wrappedTr, map, state, userId }) => {
  const commandMeta: BreakOutOfListTrackedChangeCommand = originalTr.getMeta('trackedChangeCommand')
  // from and to point before and after the list item
  const {
    meta: { from, to },
  } = commandMeta

  wrappedTr.doc.nodesBetween(from, to, (node, pos) => {
    // If the node is not fully contained between from and to, it's not the list item we are looking for
    if (pos < from || pos + node.nodeSize > to) {
      return true
    }

    // Ignore tracked deletions because it would have the same effect
    if (node.attrs.trackedChanges?.find(({ type }: TrackedChange) => type === TrackedChangeType.Deletion)) {
      return false
    }

    // If the list item was inserted, run the original command
    if (node.attrs.trackedChanges?.find(({ type }: TrackedChange) => type === TrackedChangeType.Insertion)) {
      wrappedCommand(state, wrappedTr, map)
    } else {
      const trackedChanges = getTrackedChangesFromNode(node, TrackedChangeType.Deletion, userId)
      /*
       * TODO: Types for this method are not expecting null as a second argument. We
       * should fork the types definitions and update them to match our version
       * of prosemirror-transform.
       */
      wrappedTr.setNodeMarkup(
        map.map(pos),
        // @ts-ignore
        null,
        {
          ...node.attrs,
          trackedChanges,
        },
        node.marks,
      )
    }

    return false
  })

  return true
}
